module.exports = __webpack_public_path__ + "img/ico-aws.29d9ce48.svg";